import { TournamentInvitation, TournamentInvitationWithDetails, InvitationStatus } from '../../domain/models';

export interface TournamentInvitationEntity {
  id: string;
  tournament_id: string;
  inviter_id: string;
  invitee_id: string;
  status: string;
  message?: string;
  created_at: string;
  updated_at: string;
}

export interface TournamentInvitationWithDetailsEntity extends TournamentInvitationEntity {
  tournament_name: string;
  tournament_type: string;
  tournament_status: string;
  inviter_name?: string;
  inviter_email?: string;
  inviter_avatar_url?: string;
  invitee_name?: string;
  invitee_email?: string;
  invitee_avatar_url?: string;
}

export const invitationEntityToModel = (entity: TournamentInvitationEntity): TournamentInvitation => ({
  id: entity.id,
  tournamentId: entity.tournament_id,
  inviterId: entity.inviter_id,
  inviteeId: entity.invitee_id,
  status: entity.status as InvitationStatus,
  message: entity.message,
  createdAt: new Date(entity.created_at),
  updatedAt: new Date(entity.updated_at),
});

export const invitationWithDetailsEntityToModel = (
  entity: TournamentInvitationWithDetailsEntity,
  direction: 'received' | 'sent'
): TournamentInvitationWithDetails => ({
  id: entity.id,
  tournamentId: entity.tournament_id,
  inviterId: entity.inviter_id,
  inviteeId: entity.invitee_id,
  status: entity.status as InvitationStatus,
  message: entity.message,
  createdAt: new Date(entity.created_at),
  updatedAt: new Date(entity.updated_at),
  tournamentName: entity.tournament_name,
  tournamentType: entity.tournament_type,
  tournamentStatus: entity.tournament_status,
  userName: direction === 'received' ? entity.inviter_name : entity.invitee_name,
  userEmail: direction === 'received' ? entity.inviter_email : entity.invitee_email,
  userAvatarUrl: direction === 'received' ? entity.inviter_avatar_url : entity.invitee_avatar_url,
});
